import * as Y from 'yjs';
import { createLiveYDoc, decodeDocumentYjsContent, ydocToJSON } from '@narrativebench/editor-core';
import type { Editor } from '@tiptap/core';

export const yjsUpdateFromDocumentApi = (payload: unknown): Uint8Array | null => {
  return decodeDocumentYjsContent(payload);
};

export const isUsableEditor = (editor: Editor | null): editor is Editor => {
  return Boolean(editor && !editor.isDestroyed);
};

export const applyDocumentApiContentToEditor = (payload: unknown, editor: Editor | null): void => {
  const bytes = decodeDocumentYjsContent(payload);
  if (!bytes || !isUsableEditor(editor)) {
    return;
  }

  const ydoc = createLiveYDoc();
  try {
    Y.applyUpdate(ydoc, bytes);
    const json = ydocToJSON(ydoc);
    if (json) {
      editor.commands.setContent(json);
    }
  } finally {
    ydoc.destroy();
  }
};
